{
  "view": {
    "title": "Irtisano sopimus",
    "rightOfOccupancyNoticeTitle": "Tee luovutusilmoitus",
    "description": "Tällä sivulla voit tehdä sähköisen irtisanomisilmoituksen.",
    "rightOfOccupancyNoticeDescription": "Tällä sivulla voit tehdä sähköisen luovutusilmoituksen.",
    "contractContinuesInfo": "Jos kaikki muuttavat pois, sopimus päättyy. Jos sopimusosapuoli muuttaa pois ja asuntoon jää täysi-ikäinen asukas, sopimus voi jatkua hänen nimissään.",
    "residentChangesInfo": "Muiden kuin sopimusosapuolten muutot ilmoitetaan Asukasmuutokset-sivulla."
  },
  "links": {
    "goToResidentChanges": "Siirry asukasmuutoksiin →",
    "seeResidentChanges": "Katso Asukasmuutokset →"
  },
  "headings": {
    "parties": "Osapuolet",
    "terminateForm": "Irtisanomislomake",
    "rentalTermination": "Vuokrasopimuksen irtisanominen",
    "rightOfOccupancyNotice": "Luovutusilmoitus",
    "paymentAndContactInfo": "Maksu- ja yhteystiedot",
    "paymentInfo": "Maksutiedot",
    "newAddress": "Uusi osoite",
    "showing": "Asuntonäyttö",
    "additionalDetails": "Lisätiedot",
    "leavePreviewConfirmation": "Poistutaanko lomakkeelta?",
    "terminationPreview": "Irtisanomisen esikatselu",
    "rightOfOccupancyNoticePreview": "Luovutusilmoituksen esikatselu",
    "confirmation": "Tarkista sopimusilmoitus",
    "basicInfo": "Perustiedot",
    "thankYou": "Kiitos",
    "confirmationRejected": "Irtisanomisilmoitus on hylätty.",
    "rightOfOccupancyNoticeConfirmationRejected": "Luovutusilmoitus on hylätty.",
    "contactInformation": "Yhteystiedot",
    "terminationSituation": "Mitä sopimukselle tapahtuu?"
  },
  "terminationSituations": {
    "wholeContract": "Koko sopimus päättyy",
    "wholeContractDescription": "Koko sopimus päättyy – kaikki asukkaat muuttavat pois.",
    "contractContinues": "Sopimus jatkuu asuntoon jäävällä",
    "contractContinuesDescription": "Sopimus jatkuu asuntoon jäävällä – yksi tai useampi sopimusosapuoli muuttaa pois, ja sopimus jatkuu asuntoon jäävän sopimusosapuolen tai täysi-ikäisen asukkaan nimissä."
  },
  "labels": {
    "movingOutDate": "Poismuuttopäivä",
    "contractEndDate": "Sopimuksen päättymispäivä",
    "terminationReason": "Ensisijainen irtisanomisen syy",
    "rightOfOccupancyNoticeReason": "Ensisijainen luovutusilmoituksen syy",
    "movingDestination": "Mihin olet muuttamassa",
    "files": "Liitteet",
    "beneficiaryName": "Tilinomistaja",
    "iban": "Tilinumero",
    "bic": "BIC",
    "bankCountry": "Pankin maa",
    "returnPercentage": "Palautettava osuus vakuudesta/palautuksista",
    "rooReturnPercentage": "Palautettava osuus asomaksusta",
    "email": "Sähköposti",
    "phoneNumber": "Puhelin",
    "recipientName": "Etu- ja sukunimi",
    "streetAddress": "Katuosoite",
    "streetAddressLine2": "Katuosoite (2. rivi)",
    "postalCode": "Postinumero",
    "city": "Postitoimipaikka",
    "countryName": "Maa",
    "countrySubdivision": "Alue",
    "showing": "Asunnon esittely",
    "presenter": "Esittelijä",
    "additionalDetails": "Lisätiedot",
    "givingContactInfoAllowed": "Yhteystietoni saa antaa asunnosta kiinnostuneille",
    "masterKeyAccessAllowed": "Asuntooni saa tulla yleisavaimella",
    "hasPetsInApartment": "Lemmikkejä huoneistossa",
    "terminated": "Irtisanottu",
    "rightOfOccupancyNoticeSubmitted": "Luovutusilmoitus tehty",
    "rightOfOccupancyCollateralLocation": "Asumisoikeussopimus",
    "bank": "Pankki"
  },
  "placeholders": {
    "additionalDetails": "Kirjoita irtisanomiseen liittyvät lisätiedot",
    "rightOfOccupancyNoticeAdditionalDetails": "Kirjoita luovutusilmoitukseen liittyvät lisätiedot"
  },
  "alt": {
    "successIllustration": "Kiitos kuvitus"
  },
  "buttons": {
    "backToEdit": "Takaisin muokkaamaan",
    "continueFilling": "Kyllä",
    "leavePreview": "Ei",
    "confirmTermination": "Siirry vahvistamaan",
    "rejectTermination": "Hylkää irtisanominen",
    "confirmRightOfOccupancyNotice": "Vahvista luovutusilmoitus",
    "rejectRightOfOccupancyNotice": "Hylkää luovutusilmoitus",
    "back": "Takaisin",
    "restart": "Aloita alusta"
  },
  "texts": {
    "confirmationInstruction": "Tarkasta syötetyt tiedot ja hyväksy tai hylkää irtisanominen omalta osaltasi. Jos tietoja pitää muokata, hylkää irtisanominen ja täytä irtisanomislomake uudelleen.",
    "confirmationInstructionReview": "Tarkista antamasi tiedot huolellisesti.",
    "confirmationInstructionConfirm": "Valitse <strong>{{confirmButtonLabel}}</strong> ja siirry tunnistautumaan.",
    "confirmationInstructionEdit": "Jos tietoja pitää muokata, valitse <strong>{{backToEditButtonLabel}}</strong>.",
    "terminationNoticeSentAfterConfirmation": "Irtisanomisilmoitus lähetetään vasta vahvistamisen jälkeen.",
    "rightOfOccupancyNoticeSentAfterConfirmation": "Luovutusilmoitus lähetetään vasta vahvistamisen jälkeen.",
    "terminationNoticeBeforeConfirmationInstruction": "Tarkasta tiedot seuraavassa vaiheessa ja vahvista irtisanominen tunnistautumalla.",
    "leavePreviewConfirmation": "Olet siirtymässä pois lomakkeelta. Mikäli siirryt pois lomakkeelta, täyttämiäsi tietoja ei tallenneta. Haluatko jatkaa hakemuksen täyttämistä?",
    "additionalDetailsInfo": "Voit ilmoittaa tässä lisätietoja sopimuksen irtisanomiseen liittyen. Esimerkiksi tarkentaa asunnon esittelyyn, maksupalautukseen tai lemmikkiin liittyviä tietoja.",
    "rightOfOccupancyNoticeAdditionalDetailsInfo": "Voit ilmoittaa tässä lisätietoja sopimuksen luovutusilmoitukseen liittyen. Esimerkiksi tarkentaa asunnon esittelyyn, maksupalautukseen tai lemmikkiin liittyviä tietoja.",
    "rightOfOccupancyNoticeBeforeConfirmationInstruction": "Tarkasta tiedot seuraavassa vaiheessa ja vahvista luovutusilmoitus tunnistautumalla.",
    "movingOutDateTooltip": "Asunto on tyhjä, siivottu ja avaimet palautettu.",
    "contractEndDateTooltip": "Voit halutessasi muokata sopimuksen päättymispäivää myöhemmäksi.",
    "terminationReasonTooltip": "Mikäli syitä on useita valitse tärkein.",
    "securityRestrictionWarning": "Sinulla on voimassa oleva turvakielto, joten antamiasi osoitetietoja ei näytetä muille, mukaan lukien tämän sopimuksen muut osapuolet.",
    "terminateInstructions": "Sopimuksen viimeinen voimassaolopäivä on aikaisintaan tasan 3 kuukauden päässä luovutusilmoituksesta eli {{endDate}}. Voit halutessasi muokata päättymispäivää myöhemmäksi.",
    "uploadFiles": "Lisää liitteitä klikkaamalla tai raahaamalla\nMaksimikoko on 10 Mt",
    "addReceipts": "Jos asuntoon on tehty muutostöitä, joista ei ole vielä toimitettu kuitteja, liitä ne mukaan tähän.",
    "paymentInfoReason": "Lisää tilitiedot vakuusmaksun ja mahdollisia maksupalautuksia varten. Palautettavien osuuksien tulee olla yhteensä 100 %. Täytä tiedot, vaikka vakuusmaksu ei palautuisi suoraan sinulle. Mikäli palautuksia tehdään useammalle tilille, lisää tilitiedot valitsemalla Lisää maksutiedot. Jaa tällöin palautusten osuus merkitsemällä prosenttiosuus palautuksista. Voit antaa palautuksiin liittyviä lisätietoja lomakkeen lopussa olevassa Lisätietoja-kentässä.",
    "paymentInfoReasonRental": "Lisää tilitiedot vakuusmaksun ja mahdollisia maksupalautuksia varten. Palautettavien osuuksien tulee olla yhteensä 100 %. Täytä tiedot, vaikka vakuusmaksu ei palautuisi suoraan sinulle. Mikäli palautuksia tehdään useammalle tilille, lisää tilitiedot valitsemalla Lisää maksutiedot. Jaa tällöin palautusten osuus merkitsemällä prosenttiosuus palautuksista. Voit antaa palautuksiin liittyviä lisätietoja lomakkeen lopussa olevassa Lisätietoja-kentässä.",
    "paymentInfoCollateralBankInstructions": "Palauta paperinen asumisoikeussopimus {{endDate}} mennessä osoitteeseen:\n\n{{companyName}}\n{{companyAddress}}",
    "paymentInfoCollateralBankInstructionsNoAddress": "Palauta paperinen asumisoikeussopimus {{endDate}} mennessä asumisoikeustoimistoon.",
    "addPaymentInfo": "Lisää maksutiedot",
    "bankCountryWithoutIban": "Tilinumero on syötettävä IBAN-muodossa. Jos tililläsi ei ole IBAN-numeroa, ota yhteyttä asiakaspalveluun.",
    "newAddressReason": "Tarvitsemme osoitetiedon, jotta voimme tarvittaessa toimittaa sopimuksen päättymiseen liittyvää tietoa ja mahdollisia kirjeitä. Mikäli uusi osoite ei vielä ole tiedossa, voit jättää kohdan tyhjäksi. Mikäli osoitteita on useampi (esim. muutto eri osoitteisiin) voit antaa lisätietoja lomakkeen lopussa olevassa Lisätietoja-kentässä.",
    "showingInstructions": "Kätevintä on sopia esittelystä suoraan asuntoa katsomaan tulevien kanssa. Jos kuitenkin haluat kieltää yhteystietojesi antamisen eteenpäin, asuntonäytöstä voidaan sopia myös yrityksen välityksellä.",
    "showingInstructions2": "Mikäli valitset, että yritys esittelee asuntoa hyväksyt samalla, että asuntoon voidaan tulla yleisavaimilla. Näyttöajankohdasta pyritään sopimaan osapuolien kesken ja esittelystä ilmoitetaan asukkaalle vähintään 24 tuntia ennakkoon.",
    "selectedAsPresenter": "Sinut on valittu esittelemään.",
    "terminationNotice": "Irtisanomisilmoitus",
    "movingDestinationInstructions": "Jätä tyhjäksi jos et tiedä",
    "terminateInstructionsRental": "Sopimuksen viimeinen voimassaolopäivä on seuraavan täyden kalenterikuukauden lopussa, eli aikaisintaan {{endDate}}. Voit halutessasi muokata päättymispäivää myöhemmäksi.",
    "monthEndDateUnavailable": "Annetulla aikavälillä ei ole yhtään kuukauden viimeistä päivää valittavissa. Ota yhteys asiakaspalveluun.",
    "propertyCompanyName": null,
    "propertyCompanyAddress": null,
    "propertyCompanyAddressError": "Virhe haettaessa asumisoikeussopimuksen toimitusosoitetta.",
    "confirmationAccepted": "Irtisanomisilmoitus on sinun osaltasi vahvistettu.",
    "rightOfOccupancyNoticeConfirmationAccepted": "Luovutusilmoitus on sinun osaltasi vahvistettu.",
    "fixedTermAlert": "Huomaathan, että määräaikaista sopimusta ei voi lähtökohtaisesti irtisanoa. Voit kuitenkin päättää sen ennenaikaisesti esim. toiselle paikkakunnalle muuton tai sairauden johdosta. Liitäthän tarvittavat liitteet mukaan.",
    "terminationReturnFromAuthReminder": "Muistathan, että irtisanomisilmoitus lähtee käsittelyyn vasta, kun olet tunnistautunut vahvasti ja palannut takaisin asukassivuille. Jos tunnistautuminen keskeytyy, irtisanominen jää keskeneräiseksi.",
    "rightOfOccupancyNoticeReturnFromAuthReminder": "Muistathan, että luovutusilmoitus lähtee käsittelyyn vasta, kun olet tunnistautunut vahvasti ja palannut takaisin asukassivuille. Jos tunnistautuminen keskeytyy, luovutusilmoitus jää keskeneräiseksi.",
    "allTenantsMoveOutDescription": "Sopimus päättyy kaikkien osalta. Jokainen sopimusosapuoli vahvistaa irtisanomisen omalla tunnistautumisellaan.",
    "rightOfOccupancyNoticeAllTenantsMoveOutDescription": "Sopimus päättyy kaikkien osalta. Jokainen sopimusosapuoli vahvistaa luovutusilmoituksen omalla tunnistautumisellaan."
  },
  "terminateContractReasons": {
    "buyingProperty": "Omistusasunnon hankinta",
    "moveToAnotherRental": "Muutto vuokra-asuntoon",
    "moveToRightOfOccupancy": "Muutto asumisoikeusasuntoon",
    "moveToCareHomeOrHospital": "Muutto palvelukotiin tai sairaalaan",
    "moveDueWork": "Muutto työn tai opiskelun vuoksi",
    "moveToAnotherMunicipality": "Paikkakunnan vaihto",
    "familySizeChange": "Perhekoon muutos (ero, avio/avoliitto, lapsi)",
    "apartmentSize": "Asunnon koko",
    "poorApartmentCondition": "Asunnon huono kunto",
    "poorApartmentEquipmentOrProperties": "Asunnon varusteet ja/tai ominaisuudet",
    "poorPropertyCondition": "Kiinteistön huono kunto",
    "poorPropertyMaintenance": "Kiinteistön huono hoito",
    "housingCosts": "Asumiskustannukset",
    "disturbingNeighboursOrBuilding": "Häiritsevät naapurit / häiriö talossa",
    "areaPoorServices": "Alueen huonot palvelut",
    "poorTransportationOptions": "Huonot liikenneyhteydet",
    "moveToAnotherApartmentOfSameOwner": "Muutto saman omistajan toiseen asuntoon",
    "death": "Kuolema",
    "apartmentDoesNotMeetNeeds": "Asunto ei vastaa tarpeitani",
    "apartmentTemperature": "Asunnon lämpötila",
    "apartmentLocation": "Asunnon sijainti",
    "studiesEnd": "Opinnot päättyvät",
    "rightOfOccupancyEnds": "Asumisoikeus päättyy",
    "areaDisturbances": "Asuinympäristöön liittyvät häiriöt",
    "healthReasons": "Terveydelliset syyt",
    "eviction": "Häätö",
    "renovation": "Peruskorjaus / Remontti",
    "businessClosure": "Yritystoiminnan päättyminen",
    "businessClosureInMunicipality": "Yritystoiminnan päättyminen paikkakunnalla",
    "businessStructureChange": "Yritysrakenteen muutos",
    "spaceNeedsChange": "Tilatarpeen muutos",
    "moveToMoreAffordableBusinessPremisesInMunicipality": "Siirtyminen edullisempiin tiloihin paikkakunnalla",
    "other": "Muu syy",
    "unknown": "Ei tiedossa"
  },
  "terminationDestinations": {
    "buyingProperty": "Omistusasunnon hankinta",
    "moveToAnotherApartmentOfSameOwner": "Muutto saman omistajan toiseen vuokra-asuntoon",
    "moveToAnotherRental": "Muutto toisen toimijan vuokra-asuntoon",
    "moveToRightOfOccupancyOfSameOwner": "Muutto saman omistajan asumisoikeusasuntoon",
    "moveToRightOfOccupancyOfAnotherOperator": "Muutto toisen toimijan asumisoikeusasuntoon",
    "moveToRightOfOccupancy": "Muutto asumisoikeusasuntoon",
    "moveToCareHomeOrHospital": "Muutto palvelukotiin tai sairaalaan",
    "other": "Muu syy",
    "unknown": "Ei tiedossa"
  },
  "showingSuggestions": {
    "tenant": "Asukas esittelee",
    "propertyCompanyGroup": "Yritys esittelee"
  },
  "terminateSuggestions": {
    "terminate": "Irtisano",
    "rightOfOccupancyNotice": "Luovutusilmoitus",
    "inEffect": "Voimassa",
    "pending": "Odottaa"
  },
  "rightOfOccupancyCollateralLocationSuggestions": {
    "bank": "Lainan vakuutena",
    "holder": "Asukkaalla"
  },
  "terminationDisallowedReason": {
    "contractTerminated": "Sopimus on irtisanottu.",
    "pendingTerminationTenantApprovals": "Sopimuksen irtisanominen odottaa yhden tai useamman osapuolen hyväksyntää.",
    "rightOfOccupancyNoticePendingTenantApprovals": "Luovutusilmoitus odottaa yhden tai useamman osapuolen hyväksyntää.",
    "pendingTerminationReview": "Sopimus odottaa irtisanomisen hyväksyntää.",
    "isEstateContract": "Sopimus on kuolinpesä.",
    "hasGuardianOfInterests": "Et voi irtisanoa asuntoa sähköisesti, koska yhdelle tai useammalle asukkaalle on määrätty edunvalvoja.",
    "missingResidentUsers": "Kaikilla aikuisilla asukkailla ei ole asukassivutunnusta.",
    "multipleContractParties": "Useamman sopimusosapuolen sopimuksen irtisanominen ei ole vielä mahdollista asukassivuilla.",
    "contractTags": "Sopimusta ei voi irtisanoa sähköisesti. Ota yhteyttä asiakaspalveluun.",
    "notContractParty": "Et voi irtisanoa asuntoa sähköisesti, koska et ole sopimuksen allekirjoittaja.",
    "tenantsWithUndeterminedAge": "Sopimusta ei voi irtisanoa sähköisesti, koska osa henkilötiedoista puuttuu. Ota yhteyttä asiakaspalveluun.",
    "hasCompanyTenant": "Yritysosapuolen sopimusta ei voi irtisanoa sähköisesti. Ota yhteyttä asiakaspalveluun.",
    "pendingModificationContract": "Sopimuksella on avoinna oleva muutospyyntö.",
    "pendingContractParty": "Et voi irtisanoa asuntoa sähköisesti, ennen sopimusmuutosten voimaan astumista.",
    "notStartedYet": "Sopimus ei ole vielä alkanut.",
    "openContinuationOffer": "Sopimuksellasi on avoinna oleva jatkotarjous, eikä sopimusmuutoksia asukassivuilta voi tehdä.",
    "pendingContractResign": "Sopimus odottaa uudelleenallekirjoitusta."
  },
  "confirmationError": {
    "noIdentityVerifier": "Käyttäjän henkilöllisyyttä ei voitu varmentaa",
    "noIdentity": "Käyttäjän henkilöllisyyttä ei voitu käsitellä",
    "noUser": "Käyttäjän tietojen haussa tapahtui virhe",
    "noAttributes": "Käyttäjän henkilötiedot ovat puutteelliset",
    "identityMismatch": "Henkilöllisyys ei täsmää kirjautuneeseen käyttäjään",
    "initFailed": "Irtisanomisilmoituksen vahvistamisessa tapahtui virhe",
    "cancelled": "Tunnistautuminen peruutettu",
    "addTenantInitFailed": "Asukkaan lisääminen epäonnistui",
    "movingOutDateNoLongerValid": "Poismuuttopäivä ei ole enää voimassa",
    "missingResidentCredentials": "Sopimusta ei voida tällä hetkellä irtisanoa, koska yhdellä tai useammalla sopijaosapuolella tai maksajalla ei ole asukassovelluksen tunnuksia.",
    "pendingTerminationRequest": "Sopimukselle on jo tehty irtisanomisilmoitus, joten uutta ilmoitusta ei voi lähettää."
  },
  "confirmationPendingText": "Henkilöllisyys varmennettu: voit nyt irtisanoa sopimuksen.",
  "confirmTerminationButtonText": "Irtisano sopimus",
  "confirmationErrorText": "Virhe irtisanomisilmoituksen lähetyksessä",
  "confirmErrorText": "Virhe irtisanomisilmoituksen vahvistamisessa",
  "confirmationBackButtonText": "Palaa takaisin",
  "confirmationClientError": {
    "nonceDiffFailed": "Lomakkeen varmennuksessa tapahtui virhe",
    "formValuesMissing": "Irtisanomisilmoituksen tiedot puuttuvat tai ovat virheelliset",
    "missingContractId": "Virheellinen tai puuttuva sopimuksen tunniste"
  },
  "confirmationState": {
    "confirmed": "Kiitos. Irtisanomisilmoitus on lähetetty. Saat automaattiviestin sähköpostiisi vastaanotetusta ilmoituksesta. Käsittelemme ilmoituksesi mahdollisimman pian. Mikäli viestiä ei kuulu, ole yhteydessä asiakaspalveluumme.",
    "rightOfOccupancyNoticeConfirmed": "Kiitos. Luovutusilmoitus on lähetetty. Saat automaattiviestin sähköpostiisi vastaanotetusta ilmoituksesta. Käsittelemme ilmoituksesi mahdollisimman pian. Mikäli viestiä ei kuulu, ole yhteydessä asiakaspalveluumme.",
    "pending": "Irtisanomisilmoitus on lähetetty ja odottaa muiden osapuolten hyväksyntää",
    "rightOfOccupancyNoticePending": "Luovutusilmoitus on lähetetty ja odottaa muiden osapuolten hyväksyntää",
    "rejected": "Irtisanomisilmoituksen lähetys on peruttu",
    "rightOfOccupancyNoticeRejected": "Luovutusilmoituksen lähetys on peruttu",
    "notFound": "Irtisanomisilmoituksen lähetystunnuksella ei löydy tietoja",
    "rightOfOccupancyNoticeNotFound": "Luovutusilmoituksen lähetystunnuksella ei löydy tietoja",
    "loading": "Ladataan irtisanomisilmoituksen lähetyksen tilaa..."
  },
  "errors": {
    "outOfService": "Valitettavasti sopimuksen irtisanominen ei ole tällä hetkellä mahdollista. Yritä myöhemmin uudelleen.",
    "tooEarlyToTerminate": "Sähköinen irtisanominen on mahdollista vasta kun sopimus on astunut voimaan.",
    "tooEarlyToTerminateMessage": "Ota tarvittaessa yhteys asiakaspalveluun.",
    "passportIdentityTerminateDisabled": "Sähköinen irtisanominen ei ole mahdollista vielä passilla tunnistautuneena.",
    "passportIdentityTerminateDisabledMessage": "Ota tarvittaessa yhteys asiakaspalveluun.",
    "terminationRequestUnavailable": "Irtisanomisilmoitusta ei voida juuri nyt näyttää, koska sopimuksen tiedot ovat päivittymässä."
  }
}
